import { IMAGE_TYPES } from './imageTypes';

// Default descriptions for ID documents
export const DEFAULT_DESCRIPTIONS: string[] = [
  'Do not cover any corners of the ID document',
  'Avoid any glare, shadows or dark spots on the ID document',
  'Do not use a textured background as a marble top or a print pattern',
  'Make sure the picture of the ID is clear and not blurry',
  'Make sure the picture of the ID is taken in landscape way',
];

// Selfie-specific descriptions
export const SELFIE_DESCRIPTIONS: string[] = [
  'Hold your phone in a portrait position',
  'Avoid a busy or lively background',
  'Do not use sun glasses or glasses',
  'Make sure you have enough light around',
];

// Driver License front images
import frontSlide0 from '~/assets/images/carousel/driver-license/front/dl-front-slide-1.png';
import frontSlide1 from '~/assets/images/carousel/driver-license/front/dl-front-slide-2.png';
import frontSlide2 from '~/assets/images/carousel/driver-license/front/dl-front-slide-3.png';
import frontSlide3 from '~/assets/images/carousel/driver-license/front/dl-front-slide-4.png';
import frontSlide4 from '~/assets/images/carousel/driver-license/front/dl-front-slide-5.png';

// Driver License back images
import backSlide0 from '~/assets/images/carousel/driver-license/back/dl-back-slide-1.png';
import backSlide1 from '~/assets/images/carousel/driver-license/back/dl-back-slide-2.png';
import backSlide2 from '~/assets/images/carousel/driver-license/back/dl-back-slide-3.png';
import backSlide3 from '~/assets/images/carousel/driver-license/back/dl-back-slide-4.png';
import backSlide4 from '~/assets/images/carousel/driver-license/back/dl-back-slide-5.png';

// Selfie images
import selfieSlide0 from '~/assets/images/carousel/selfie/selfie-slide-1.png';
import selfieSlide1 from '~/assets/images/carousel/selfie/selfie-slide-2.png';
import selfieSlide2 from '~/assets/images/carousel/selfie/selfie-slide-3.png';
import selfieSlide3 from '~/assets/images/carousel/selfie/selfie-slide-4.png';

// Passport images
import passportSlide0 from '~/assets/images/carousel/passport/passport-slide-1.png';
import passportSlide1 from '~/assets/images/carousel/passport/passport-slide-2.png';
import passportSlide2 from '~/assets/images/carousel/passport/passport-slide-3.png';

const frontSlides = [frontSlide0, frontSlide1, frontSlide2, frontSlide3, frontSlide4];
const backSlides = [backSlide0, backSlide1, backSlide2, backSlide3, backSlide4];
const selfieSlides = [selfieSlide0, selfieSlide1, selfieSlide2, selfieSlide3];
const passportSlides = [passportSlide0, passportSlide1, passportSlide2];

// Create tip data objects
export const TIPS_DATA: Record<string, { imgUrl: string, description: string }[]> = {
  [IMAGE_TYPES.DL_FRONT]: frontSlides.map((imgUrl, index) => ({
    imgUrl,
    description: DEFAULT_DESCRIPTIONS[index]
  })),

  [IMAGE_TYPES.DL_BACK]: backSlides.map((imgUrl, index) => ({
    imgUrl,
    description: DEFAULT_DESCRIPTIONS[index]
  })),

  [IMAGE_TYPES.SELFIE]: selfieSlides.map((imgUrl, index) => ({
    imgUrl,
    description: SELFIE_DESCRIPTIONS[index]
  })),

  [IMAGE_TYPES.PASSPORT]: passportSlides.map((imgUrl, index) => ({
    imgUrl,
    description: DEFAULT_DESCRIPTIONS[index]
  }))
};
